import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Col, message, Modal, notification, Row } from "antd";
import "../../assets/css/notification.css";
import { SUCCESS_ICON_ALERT } from "../../assets/svg/svgIcon";
import HButton from "../../components/custom/input/button/Button";
import { APP_REACT_URL } from "../../constants/AppConstants";
import { FundsMonitor } from "./FundsMonitor";

export const successNotificationWithBtn = (notificationMessage, appProperties) => {
  var urlParams = new URLSearchParams(window.location.search);

  urlParams.set("sideBar", true);
  urlParams.set("topBar", true);
  var campaignLink = "/campaigns?" + urlParams;
  if (appProperties?.controller?.campaignLink) {
    campaignLink = `${APP_REACT_URL}/campaigns?leftServiceId=${appProperties.leftServiceId}&service=zohocrmredirect&domain=org${appProperties.companyId}&action=settings&userId=${appProperties.userId}&companyId=${appProperties.companyId}&onInstall=true&version=2`;
  }
  notification.destroy();
  notification.open({
    message: (
      <div className="h-100 d-flex justify-content-between">
        <div className="overflow-scroll" style={{ maxHeight: "70px" }}>
          {notificationMessage}
        </div>
        <div className="me-2">
          <Button
            style={{
              color: "#009EFD",
              background: "#C9EBFF",
              fontSize: 13,
            }}
            type="text"
            target="_blank"
            href={campaignLink}
          >
            View Report
          </Button>
        </div>
      </div>
    ),
    className: "successNotify",
    icon: <div className="staticIconsSprite successIcon" />,
    placement: "bottomLeft",
    duration: 0,
  });
};
export const successNotification = (notificationMessage) => {
  message.success(<span data-cy="success-notification">{notificationMessage}</span>);
};
export const errorNotification = (notificationMessage) => {
  message.error(notificationMessage);
};
export const successNotifyWithDescription = (notificationMessage, messageDescription) => {
  message.success(<span data-cy="success-notification">{messageDescription}</span>);
};

export const failurePricingNotificationWithBtn = (title, errorMessage, button, appProperties, stripeLink) => {
  const isMobileApp = navigator.userAgent.includes("HelloSendMobile");

  const registerChargeBee = (e) => {
    if (stripeLink) {
      window.open(stripeLink);
    } else {
      window.Chargebee?.registerAgain();
    }
  };

  const openNotification = (btnContent) => {
    notification.destroy();
    notification.open({
      message: <div className="ms-2">{title}</div>,
      description: <div className="pe-3 ps-2">{errorMessage}</div>,
      className: "pe-2 ps-2",
      icon: (
        <div className="container h-100">
          <div className="row h-100">
            <div className="col d-flex justify-content-center align-items-center">
              <FailureCommonIcon />
            </div>
          </div>
        </div>
      ),
      btn: btnContent,
      placement: "bottomLeft",
      duration: 0,
    });
  };

  if (isMobileApp) {
    openNotification(null);
  } else if (
    appProperties?.licenseObj?.licenseDetails?.licenseStatus === 4 ||
    appProperties?.licenseObj?.licenseDetails?.licenseStatus === 5
  ) {
    appProperties.controller.pricingLink(appProperties).then((resp) => {
      openNotification(
        <Button
          className="hs-bg-violet hs-hover-none d-flex align-items-center px-4 text-white hs-text-decoration-none hs-border-5 me-3"
          target="_blank"
          href={resp}
        >
          {button}
        </Button>
      );
    });
  } else {
    const buttonProps = stripeLink ? {} : { onMouseEnter: registerChargeBee };
    openNotification(
      <Button
        {...buttonProps}
        data-cb-type="portal"
        onClick={registerChargeBee}
        className="hs-bg-violet hs-hover-none d-flex align-items-center px-4 text-white hs-text-decoration-none hs-border-5 me-3"
      >
        {button}
      </Button>
    );
  }
};

export const infoNotificationWithLink = (infoMessage, helpMsg, mailId) => {
  notification.destroy();
  notification.open({
    message: (
      <div>
        <div>
          <Row style={{ paddingRight: 10 }}>
            <div style={{ paddingTop: 4, paddingLeft: "1rem" }}>{infoMessage}</div>
            <div style={{ paddingTop: 7, paddingLeft: "1rem" }}>
              <a
                style={{
                  color: "#FF507A",
                  padding: 0,
                  fontSize: 13,
                }}
                href={mailId}
              >
                {helpMsg}
              </a>
            </div>
          </Row>
        </div>
      </div>
    ),
    icon: (
      <div className="container h-100">
        <div className="row h-100">
          <div className="col d-flex justify-content-center align-items-center text-warning mt-2">
            <InfoCircleOutlined />
          </div>
        </div>
      </div>
    ),
    placement: "bottomLeft",
    duration: 20,
  });
};

export const successNotificationViewReport = (infoMessage, helpMsg, mailId) => {
  notification.destroy();
  notification.open({
    message: (
      <div>
        <div>
          <Row style={{ paddingRight: 10 }}>
            <Col span={24} style={{ paddingTop: 7, paddingLeft: 5 }}>
              {infoMessage}
            </Col>
          </Row>
        </div>
      </div>
    ),
    icon: (
      <div className="container h-100 pt-2 pe-3">
        <div className="row h-100">
          <div className="col d-flex justify-content-center align-items-center">
            <SUCCESS_ICON_ALERT />
          </div>
        </div>
      </div>
    ),
    placement: "bottomLeft",
    duration: 3,
  });
};

export const failureNotificationCredits = (errorMessage) => {
  notification.destroy();
  notification.open({
    message: (
      <div>
        <div>
          <Row style={{ paddingRight: 10 }}>
            <Col span={24} style={{ paddingTop: 7 }}>
              {errorMessage}
            </Col>
            <Col span={2} offset={1} style={{ paddingTop: 3 }}>
              <div>
                <FundsMonitor popOver={false} />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    ),
    icon: (
      <div className="container h-100 pt-2">
        <div className="row h-100">
          <div className="col d-flex justify-content-center align-items-center">
            <FailureCommonIcon />
          </div>
        </div>
      </div>
    ),
    placement: "bottomLeft",
    duration: 3,
  });
};

const FailureCommonIcon = () => {
  return (
    <div>
      <span
        role="img"
        aria-label="close-circle"
        className="anticon anticon-close-circle ant-notification-notice-icon ant-notification-notice-icon-error"
      >
        <svg
          fillRule="evenodd"
          viewBox="64 64 896 896"
          focusable="false"
          data-icon="close-circle"
          width="1em"
          height="1em"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"></path>
        </svg>
      </span>
    </div>
  );
};

export const requestBrowserNotificationPermission = () => {
  if ("Notification" in window) {
    if (Notification.permission === "default" || Notification.permission === "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
        }
      });
    }
  }
};

export const showBrowserNotification = (title, body) => {
  if (Notification.permission === "granted") {
    const notification = new Notification(title, {
      body: body,
    });

    notification.onclick = () => window.focus();
  }
};

export const PlanModal = ({ isOpen, type, modalConfigs, onClose, onConfirm, spinButton }) => {
  const config = modalConfigs[type];

  const modalBody = (
    <div className="d-flex justify-content-start gap-3 flex-column">
      <div className="d-flex justify-content-start">
        <div className="voice-plan-switch-modal-icon call-action-icons" />
      </div>

      <div className="d-flex justify-content-start align-items-center">
        <div className="d-flex justify-content-start flex-column">
          <span className="hs-color-dark-blue hs-fw-800 hs-fs-16">{config.title}</span>
          <div className="hs-color-dark-blue pt-3">{config.message}</div>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between w-100 pt-3">
        <div className="w-50 d-flex align-items-center justify-content-start">
          <HButton type="secondary" buttonClassName="hs-w-90 hs-fw-600" variant="cancel" onClick={onClose}>
            Cancel
          </HButton>
        </div>

        <div className="w-50 d-flex align-items-center justify-content-end">
          <HButton type="primary" buttonClassName="w-100 hs-fw-600" onClick={onConfirm} loading={spinButton}>
            {config.confirmText}
          </HButton>
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      width={400}
      mask={true}
      closeIcon={<div className="actionIconsSprite modalCloseIcon" />}
      onCancel={onClose}
      open={isOpen}
      footer={null}
      centered={true}
      closable={true}
    >
      {modalBody}
    </Modal>
  );
};

export const SecondaryConfirmationModal = ({
  isOpen,
  type,
  modalConfigs,
  onClose,
  onConfirm,
  spinButton,
  defaultModalIcon = "voice-plan-switch-modal-icon call-action-icons",
}) => {
  const config = modalConfigs[type];

  const modalBody = (
    <div className="d-flex justify-content-start gap-3 flex-column">
      <div className="d-flex justify-content-start">
        <div className={defaultModalIcon} />
      </div>

      <div className="d-flex justify-content-center align-items-center">
        <div className="d-flex justify-content-center flex-column">
          <span className="hs-color-dark-blue hs-fw-800 hs-fs-16">{config.title}</span>
          <div className="hs-color-dark-blue pt-3">{config.message}</div>
          <div className="hs-color-dark-blue pt-3">{config.secondaryMessage}</div>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between w-100 pt-3">
        <div className="w-50 d-flex align-items-center justify-content-start">
          <HButton type="secondary" buttonClassName="hs-w-90 hs-fw-600" variant="cancel" onClick={onClose}>
            Cancel
          </HButton>
        </div>

        <div className="w-50 d-flex align-items-center justify-content-end">
          <HButton type="primary" buttonClassName="w-100 hs-fw-600" onClick={onConfirm} loading={spinButton}>
            {config.confirmText}
          </HButton>
        </div>
      </div>
    </div>
  );

  return (
    <Modal width={400} mask={true} onCancel={onClose} open={isOpen} footer={null} centered={true} closable={true}>
      {modalBody}
    </Modal>
  );
};
